export default {
  oll: [
    {
      name: 'OCLL6 - OLL 26',
      tf: ['TM', 'TR', 'ML', 'MM', 'MR', 'BM'],
      sf: ['BL', 'LT', 'RB'],
      chance: 54,
      algorithms: [
        ["RU2R'U'RU'R'"],
        ["y'R'U'RU'R'U2R"],
      ],
    },

    {
      name: 'OCLL7 - OLL 27',
      tf: ['TM', 'ML', 'MM', 'MR', 'BL', 'BM'],
      sf: ['TL', 'RT', 'BR'],
      chance: 54,
      algorithms: [
        ["R U R' U R U2' R'"],
        ["y' R' U2' R U R' U R"],
      ],
    },

    {
      name: 'OCLL1 - OLL 21',
      tf: ['TM', 'ML', 'MM', 'MR', 'BM'],
      sf: ['TL', 'TR', 'BL', 'BR'],
      chance: 108,
      algorithms: [
        ["R U2 R'", "U' R U R'", "U' R U' R'"],
        ['y', "R U R' U", "R U' R' U", "R U2' R'"],
      ],
    },


    {
      name: 'OCLL2 - OLL 22',
      tf: ['TM', 'ML', 'MM', 'MR', 'BM'],
      sf: ['LT', 'LB', 'TR', 'BR'],
      chance: 54,
      algorithms: [
        ["R U2' R2' U' R2 U' R2' U2' R "],
      ],
    },

    {
      name: 'OCLL4 - OLL24',
      tf: ['TM', 'TR', 'MM', 'ML', 'MR', 'BM', 'BR'],
      sf: ['TL', 'BL'],
      chance: 54,
      algorithms: [
        ["r U R' U'", "r' F R F'"],
        ['y', 'R U R D', "R' U' R D'", "R2'"],
      ],
    },

    {
      name: 'OCLL5 - OLL 25',
      tf: ['TL', 'TM', 'ML', 'MM', 'MR', 'BM', 'BR'],
      sf: ['RT', 'BL'],
      chance: 54,
      algorithms: [
        ["yF'", "rUR'U'", "r'FR"],
        ['x', "R'UR", "D'", "R'U'R", "Dx'"],
      ],
    },

    {
      name: 'OCLL3 - OLL 23',
      tf: ['TL', 'TM', 'TR', 'ML', 'MM', 'MR', 'BM'],
      sf: ['BL', 'BR'],
      chance: 54,
      algorithms: [
        ['R2D', "R'U2R", "D'", "R'U2R'"],
        ["y2R2'D'", "RU2R'", 'D', 'RU2R'],
      ],
    },

    {
      name: 'T1 - OLL 33',
      tf: ['TR', 'ML', 'MM', 'MR', 'BR'],
      sf: ['TL', 'TM', 'BL', 'BM'],
      chance: 54,
      algorithms: [
        ["RUR'U'", "R'FRF'"],
      ],
    },

    {
      name: 'T2 - OLL 45',
      tf: ['TR', 'ML', 'MM', 'MR', 'BR'],
      sf: ['TM', 'LT', 'LB', 'BM'],
      chance: 54,
      algorithms: [
        ['F', "RUR'U'", "F'"],
      ],
    },

    {
      name: 'S1 - OLL 5',
      tf: ['MM', 'MR', 'BM', 'BR'],
      sf: ['TL', 'TM', 'LM', 'LB', 'RT'],
      chance: 54,
      algorithms: [
        ["r'U2'RUR'Ur"],
      ],
    },

    {
      name: 'S2 - OLL 6',
      tf: ['MM', 'MR', 'TM', 'TR'],
      sf: ['LT', 'LM', 'BL', 'BM', 'RB'],
      chance: 54,
      algorithms: [
        ["rU2R'U'RU'r'"],
      ],
    },

    {
      name: 'C1 - OLL 34',
      tf: ['ML', 'MM', 'MR', 'BL', 'BR'],
      sf: ['TM', 'LT', 'RT', 'BM'],
      chance: 54,
      algorithms: [
        ["RUR2'U'", "R'FRU", "RU'F'"],
      ],
    },

    {
      name: 'C2 - OLL 46',
      tf: ['TL', 'TM', 'MM', 'BL', 'BM'],
      sf: ['LM', 'RT', 'RM', 'RB'],
      chance: 54,
      algorithms: [
        ["R'U'", "R'FRF'", 'UR'],
      ],
    },

    {
      name: 'W1 - OLL 36',
      tf: ['TL', 'ML', 'MM', 'BM', 'BR'],
      sf: ['TM', 'RT', 'RM', 'BL'],
      chance: 54,
      algorithms: [
        ["R'U'RU'", "R'URU", "lU'R'Ux"],
        ['y2', "RUR'F'", "RUR'U'", "R'FRU'", "R'FRF'"],
      ],
    },

    {
      name: 'W2 - OLL 38',
      tf: ['TM', 'TR', 'ML', 'MM', 'BL'],
      sf: ['TL', 'RM', 'RB', 'BM'],
      chance: 54,
      algorithms: [
        ["RUR'U", "RU'R'U'", "R'FRF'"],
      ],
    },

    {
      name: 'E1 - OLL 28',
      tf: ['TL', 'TM', 'TR', 'ML', 'MM', 'BL', 'BR'],
      sf: ['RM', 'BM'],
      chance: 54,
      algorithms: [
        ["rUR'U'", 'M', "URU'R'"],
      ],
    },

    {
      name: 'E2 - OLL 57',
      tf: ['TL', 'TR', 'ML', 'MM', 'MR', 'BL', 'BR'],
      sf: ['TM', 'BM'],
      chance: 108,
      algorithms: [
        ["RUR'U'", "M'", "URU'r'"],
      ],
    },

    {
      name: 'P1 - OLL 31',
      tf: ['TM', 'TR', 'MM', 'MR', 'BR'],
      sf: ['TL', 'LM', 'BL', 'BM'],
      chance: 54,
      algorithms: [
        ["R'U'F", "URU'R'", "F'R"],
      ],
    },

    {
      name: 'P2 - OLL 32',
      tf: ['TR', 'MM', 'MR', 'BM', 'BR'],
      sf: ['TL', 'TM', 'LM', 'BL'],
      chance: 54,
      algorithms: [
        ["RUB'", "U'R'U", "RBR'"],
        ['S', "RUR'U'", "R'FRf'"],
      ],
    },

    {
      name: 'P3 - OLL 43',
      tf: ['TL', 'ML', 'MM', 'BL', 'BM'],
      sf: ['TM', 'RT', 'RM', 'RB'],
      chance: 54,
      algorithms: [
        ["yR'U'F'UFR"],
        ["f'", "L'U'LU", 'f'],
      ],
    },

    {
      name: 'P4 - OLL 44',
      tf: ['TR', 'MM', 'MR', 'BM', 'BR'],
      sf: ['TM', 'LT', 'LM', 'LB'],
      chance: 54,
      algorithms: [
        ['f', "RUR'U'", "f'"],
        ['y2F', "URU'R'", "F'"],
      ],
    },

    {
      name: 'I1 - OLL 51',
      tf: ['ML', 'MM', 'MR'],
      sf: ['TM', 'TR', 'LT', 'LB', 'BM', 'BR'],
      chance: 54,
      algorithms: [
        ['f', "RUR'U'", "RUR'U'", "f'"],
        ['y2F', "URU'R'", "URU'R'", "F'"],
      ],
    },

    {
      name: 'I4 - OLL 56',
      tf: ['ML', 'MM', 'MR'],
      sf: ['TM', 'LT', 'LB', 'RT', 'RB', 'BM'],
      chance: 108,
      algorithms: [
        ["r'U'r", "U'R'UR", "U'R'UR", "r'Ur"],
      ],
    },

    {
      name: 'I2 - OLL 52',
      tf: ['TM', 'MM', 'Bm'],
      sf: ['TL', 'LM', 'RT', 'RM', 'RB', 'BL'],
      chance: 54,
      algorithms: [
        ["R'U'RU'R'U", "y'", "R'UR", 'B'],
        ["RUR'URU'", 'y', "RU'R'", "F'"],
      ],
    },

    {
      name: 'I3 - OLL 55',
      tf: ['TM', 'MM', 'BM'],
      sf: ['LT', 'LM', 'LB', 'RT', 'RM', 'RB'],
      chance: 108,
      algorithms: [
        ['y', "R'FRU", "RU'R2'F'", "R2U'R'", "URUR'"],
      ],
    },

    {
      name: 'F1 - OLL 9',
      tf: ['TM', 'ML', 'MM', 'BR'],
      sf: ['TR', 'LT', 'RM', 'BL', 'BM'],
      chance: 54,
      algorithms: [
        ["RUR'U'", "R'F", "R2UR'U'", "F'"],
        ["R'U'R", "yrU'r'UrUr'"],
      ],
    },

    {
      name: 'F2 - OLL 10',
      tf: ['TR', 'ML', 'MM', 'BM'],
      sf: ['TL', 'TM', 'LB', 'RM', 'BR'],
      chance: 54,
      algorithms: [
        ["RUR'U", "R'FRF'", "RU2'R'"],
        ["RUR'", 'y', "R'FRU'", "R'F'R"],
      ],
    },

    {
      name: 'F3 - OLL 35',
      tf: ['TL', 'MM', 'MR', 'BM', 'BR'],
      sf: ['TM', 'LM', 'RT', 'BL'],
      chance: 54,
      algorithms: [
        ["RU2'", "R2'FRF'", "RU2'R'"],
      ],
    },

    {
      name: 'F4 - OLL 37',
      tf: ['TL', 'TM', 'ML', 'MM', 'BR'],
      sf: ['RT', 'RM', 'BL', 'BM'],
      chance: 54,
      algorithms: [
        ['F', "RU'R'U'", "RUR'F'"],
      ],
    },

    {
      name: 'K1 - OLL 13',
      tf: ['ML', 'MM', 'MR', 'BL'],
      sf: ['TL', 'TM', 'RT', 'BM', 'BR'],
      chance: 54,
      algorithms: [
        ["rU'r'", "U'rUr'", "y'", "R'UR"],
        ["FURU'R2'F'RU", "RU'R'"],
      ],
    },

    {
      name: 'K2 - OLL 14',
      tf: ['ML', 'MM', 'MR', 'BR'],
      sf: ['TM', 'TR', 'LT', 'BL', 'BM'],
      chance: 54,
      algorithms: [
        ["R'FR", "UR'F'R", "FU'F'"],
      ],
    },

    {
      name: 'K4 - OLL 16',
      tf: ['TR', 'ML', 'MM', 'MR'],
      sf: ['TM', 'LT', 'RB', 'ML', 'MM'],
      chance: 54,
      algorithms: [
        ["rUr'", "RUR'U'", "rU'r'"],
      ],
    },

    {
      name: 'K3 - OLL 15',
      tf: ['ML', 'MM', 'MR', 'BR'],
      sf: ['TL', 'TM', 'LB', 'RT', 'BM'],
      chance: 54,
      algorithms: [
        ["r'U'r", "R'U'RU", "r'Ur"],
      ],
    },

    {
      name: 'A1 - OLL 29',
      tf: ['TL', 'TR', 'ML', 'MM', 'BM'],
      sf: ['TM', 'LB', 'RM', 'RB'],
      chance: 54,
      algorithms: [
        ['y', "RUR'U'", "RU'R'", "F'U'F", "RUR'"],
        ['MU', "RUR'U'", "R'FRF'", "M'"],
      ],
    },

    {
      name: 'A2 - OLL 30',
      tf: ['TL', 'TM', 'MM', 'MR', 'BL'],
      sf: ['TR', 'LM', 'BM', 'BR'],
      chance: 54,
      algorithms: [
        ["y'FU", "RU2R'U'", "RU2R'U'", "F'"],
        ["y'", "FR'F", "R2U'R'U'", "RUR'", 'F2'],
      ],
    },

    {
      name: 'A3 - OLL 41',
      tf: ['TM', 'ML', 'MM', 'BL', 'BR'],
      sf: ['TL', 'TR', 'RM', 'BM'],
      chance: 54,
      algorithms: [
        ["RUR'URU2'R'", 'F', "RUR'U'", "F'"],
      ],
    },

    {
      name: 'A4 - OLL 42',
      tf: ['TL', 'TR', 'ML', 'MM', 'BM'],
      sf: ['TM', 'RM', 'BL', 'BR'],
      chance: 54,
      algorithms: [
        ["R'U'RU'R'U2R", 'F', "RUR'U'", "F'"],
        ['y', "R'FRF'", "R'FRF'", "RUR'U'", "RUR'"],
      ],
    },

    {
      name: 'L2 - OLL 48',
      tf: ['TM', 'ML', 'MM'],
      sf: ['TR', 'LT', 'LB', 'RM', 'BM', 'BR'],
      chance: 54,
      algorithms: [
        ['F', "RUR'U'", "RUR'U'", "F'"],
      ],
    },

    {
      name: 'L1 - OLL 47',
      tf: ['TM', 'MM', 'MR'],
      sf: ['TL', 'LM', 'RT', 'RB', 'BL', 'BM'],
      chance: 54,
      algorithms: [
        ["F'", "L'U'LU", "L'U'LU", 'F'],
        ["R'U'", "R'FRF'", "R'FRF'", 'UR'],
      ],
    },

    {
      name: 'L3 - OLL 49',
      tf: ['TM', 'MM', 'MR'],
      sf: ['TR', 'LT', 'LM', 'LB', 'BM', 'BR'],
      chance: 54,
      algorithms: [
        ["rU'r2'Ur2Ur2'U'r"],
      ],
    },

    {
      name: 'L4 - OLL 50',
      tf: ['MM', 'MR', 'BM'],
      sf: ['TM', 'TR', 'LT', 'LM', 'LB', 'BR'],
      chance: 54,
      algorithms: [
        ["r'Ur2U'r2'U'r2Ur'"],
        ["y'", "RU2R'U'RU'R'", 'F', "RUR'U'", "F'"],
      ],
    },

    {
      name: 'L5 - OLL 53',
      tf: ['MM', 'MR', 'BM'],
      sf: ['TM', 'LT', 'LM', 'LB', 'RT', 'RB'],
      chance: 54,
      algorithms: [
        ["r'U'RU'", "R'URU'", "R'U2r"],
        ["yr'U2'R", "UR'U'R", "UR'Ur"],
      ],
    },

    {
      name: 'L6 - OLL 54',
      tf: ['TM', 'MM', 'MR'],
      sf: ['LT', 'LM', 'LB', 'RT', 'RB', 'BM'],
      chance: 54,
      algorithms: [
        ["rUR'U", "RU'R'U", "RU2'r'"],
        ["y'", "rU2R'U'", "RUR'U'", "RU'r'"],
      ],
    },

    {
      name: 'B1 - OLL 7',
      tf: ['TM', 'ML', 'MM', 'BL'],
      sf: ['TL', 'RT', 'RM', 'BM', 'BR'],
      chance: 54,
      algorithms: [
        ["rUR'URU2'r'"],
      ],
    },

    {
      name: 'B2 - OLL 8',
      tf: ['TL', 'ML', 'MM', 'BM'],
      sf: ['TM', 'TR', 'RM', 'RB', 'BL'],
      chance: 54,
      algorithms: [
        ["r'U'RU'R'U2r"],
        ["y2l'U'LU'L'U2l"],
      ],
    },

    {
      name: 'B3 - OLL 11',
      tf: ['MM', 'MR', 'BL', 'BM'],
      sf: ['TL', 'TM', 'LM', 'RT', 'BR'],
      chance: 54,
      algorithms: [
        ["r'", "R2UR'URU2R'", "UM'"],
      ],
    },

    {
      name: 'B4 - OLL 12',
      tf: ['TL', 'TM', 'MM', 'MR'],
      sf: ['TR', 'LM', 'RB', 'BL', 'BM'],
      chance: 54,
      algorithms: [
        ["M'", "R'U'RU'R'U2R", "U'M"],
        ['yF', "RUR'U'", "F'UF", "RUR'U'", "F'"],
      ],
    },

    {
      name: 'B5 - OLL 39',
      tf: ['TR', 'ML', 'MM', 'MR', 'BL'],
      sf: ['TL', 'TM', 'RB', 'BM'],
      chance: 54,
      algorithms: [
        ["LF'", "L'U'LU", "FU'L'"],
        ['F', "RUR'U'", "F'", "R'U'RU'R'U2R"],
      ],
    },

    {
      name: 'B6 - OLL 40',
      tf: ['TL', 'ML', 'MM', 'MR', 'BR'],
      sf: ['TM', 'TR', 'LB', 'BM'],
      chance: 54,
      algorithms: [
        ["R'F", "RUR'U'", "F'UR"],
      ],
    },

    {
      name: 'O1 - OLL 1',
      tf: ['MM'],
      sf: ['TM', 'LT', 'LM', 'LB', 'RT', 'RM', 'RB', 'BM'],
      chance: 108,
      algorithms: [
        ["RU2'", "R2'FRF'", "U2'", "R'FRF'"],
      ],
    },

    {
      name: 'O2 - OLL 2',
      tf: ['MM'],
      sf: ['TM', 'TR', 'LT', 'LM', 'LB', 'RM', 'BM', 'BR'],
      chance: 54,
      algorithms: [
        ['F', "RUR'U'", "F'f", "RUR'U'", "f'"],
        ['y', "rUr'", "U2RU2'R'U2", "rU'r'"],
      ],
    },

    {
      name: 'O3 - OLL 3',
      tf: ['MM', 'BR'],
      sf: ['TL', 'TM', 'LM', 'LB', 'RT', 'RM', 'BM'],
      chance: 54,
      algorithms: [
        ['f', "RUR'U'", "f'U'F", "RUR'U'", "F'"],
      ],
    },

    {
      name: 'O4 - OLL 4',
      tf: ['TR', 'MM'],
      sf: ['TM', 'LT', 'LM', 'RM', 'RB', 'BL', 'BM'],
      chance: 54,
      algorithms: [
        ['f', "RUR'U'", "f'UF", "RUR'U'", "F'"],
      ],
    },

    {
      name: 'O6 - OLL 18',
      tf: ['MM', 'BR'],
      sf: ['TL', 'TM', 'LM', 'LB', 'RT', 'RM', 'BM'],
      chance: 54,
      algorithms: [
        ["yRU2'", "R2'FRF'", "U2'M'", "URU'r'"],
        ["rUR'URU2r'", "r'U'RU'R'U2r"],
      ],
    },

    {
      name: 'O7 - OLL 19',
      tf: ['TL', 'TR', 'MM'],
      sf: ['TM', 'LM', 'LB', 'RM', 'RB', 'BM'],
      chance: 54,
      algorithms: [
        ['MU', "RUR'U'", "M'", "R'FRF'"],
      ],
    },

    {
      name: 'O5 - OLL 17',
      tf: ['TL', 'MM', 'BR'],
      sf: ['TM', 'TR', 'LM', 'LB', 'RM', 'BM'],
      chance: 54,
      algorithms: [
        ["RUR'U", "R'FRF'", "U2'", "R'FRF'"],
      ],
    },

    {
      name: 'O8 - OLL 20',
      tf: ['TL', 'TR', 'MM', 'BL', 'BR'],
      sf: ['TM', 'LM', 'RM', 'BM'],
      chance: 216,
      algorithms: [
        ['MU', "RUR'U'", "M2'", "URU'r'"],
        ["rUR'U'", "M2'", "URU'R'", "U'M'"],
      ],
    },
  ],

  pll: [
    {
      name: 'Ub Perm',
      sf: 'BBBOGOGRGROR',
      arrows: [['LMRM', 'RMMM'], ['RMLB', 'MBMM'], ['MBLT', 'LMMM']],
      chance: 18,
      algorithms: [
        ['R2U', "RUR'U'", "R'U'", "R'UR'"],
        ['y2', "R'UR'U'", "R'U'", "R'URU", "R2'"],
      ],
    },

    {
      name: 'Ua Perm',
      sf: 'BBBOROGOGRGR',
      arrows: [['RMLM', 'LMMM'], ['LMRB', 'MBMM'], ['MBRT', 'RMMM']],
      chance: 18,
      algorithms: [
        ["RU'RU", 'RU', "RU'R'U'", 'R2'],
        ['y2', "RUR'U", "R'U'R2U'", "R'UR'UR[U2]"],
        ['y2', "R2U'R'U'", 'RURU', "RU'R"],
      ],
    },

    {
      name: 'Z Perm',
      sf: 'BRBOGOGOGRBR',
      arrows: [['LMMM', 'MTMM'], ['MTMM', 'LMMM'], ['MBMM', 'RMMM'], ['RMMM', 'MBMM']],
      chance: 36,
      algorithms: [
        ["M2'UM2'U", "M'U2", "M2'U2M'", '[U2]'],
        ["y'M'U", "M2'UM2'", 'U', "M'U2M2", "[U']"],
      ],
    },

    {
      name: 'H Perm',
      sf: 'OROGBGRORBGB',
      arrows: [['MTMM', 'MBMM'], ['MBMM', 'MTMM'], ['LMMM', 'RMMM'], ['RMMM', 'LMMM']],
      chance: 72,
      algorithms: [
        ["M2'UM2'", 'U2', "M2'UM2'"],
      ],
    },

    {
      name: 'Aa Perm',
      sf: 'GOGRGBORRBBO',
      arrows: [['LTRM', 'RTMM'], ['RTMB', 'RBMM'], ['RBLT', 'LTMM']],
      chance: 18,
      algorithms: [
        ['x', "R'UR'", 'D2', "RU'R'", "D2R2x'"],
        ["yx'R2D2", "R'U'R", 'D2', "R'UR'", 'x'],
      ],
    },

    {
      name: 'Ab Perm',
      sf: 'ROBOGOGRRBBG',
      arrows: [['RTLM', 'LTMM'], ['LTRB', 'RBMM'], ['RBMT', 'RTMM']],
      chance: 18,
      algorithms: [
        ["xR2'D2", "RUR'", 'D2', "RU'R", "x'"],
        ["yx'", "RU'R", 'D2', "R'UR", "D2R2'x"],
      ],
    },

    {
      name: 'E Perm',
      sf: 'BOGRGOGRBOBR',
      arrows: [['LTMM', 'LBMM'], ['LBMM', 'LTMM'], ['RTMM', 'RBMM'], ['RBMM', 'RTMM']],
      chance: 36,
      algorithms: [
        ["x'", "RU'R'D", "RUR'D'", "RUR'D", "RU'R'D'", 'x'],
      ],
    },

    {
      name: 'Ra Perm',
      sf: 'BROGOBOGGRBR',
      arrows: [['LMMM', 'MTMM'], ['MTMM', 'LMMM'], ['RTMM', 'RBMM'], ['RBMM', 'RTMM']],
      chance: 18,
      algorithms: [
        ["RU'R'U'", 'RURD', "R'U'RD'", "R'U2R'", "[U']"],
        ["y'", "LU2L'U2", "LF'", "L'U'LU", "LFL2'[U]"],
        ["RUR'F'", "RU2'R'U2'", "R'FRU", "RU2'R'", "[U']"],
      ],
    },

    {
      name: 'Rb Perm',
      sf: 'GOBORGRGRBBO',
      arrows: [['LTMM', 'RTMM'], ['RTMM', 'LTMM'], ['MBMM', 'RMMM'], ['RMMM', 'MBMM']],
      chance: 18,
      algorithms: [
        ["R'U2RU2'", "R'F", "RUR'U'", "R'F'R2[U']"],
        ["R'U2R'D'", "RU'R'D", "RURU'", "R'U'R", "[U']"],
      ],
    },

    {
      name: 'Ja',
      sf: 'ORRBOOGGGRBB',
      arrows: [['LTMM', 'RTMM'], ['RTMM', 'LTMM'], ['LMMM', 'MTMM'], ['MTMM', 'LMMM']],
      chance: 18,
      algorithms: [
        ["R'UL'U2", "RU'R'U2R", "L[U']"],
        ["y'", "L'U'LF", "L'U'LU", "LF'L2'UL[U]"],
      ],
    },

    {
      name: 'Jb Perm',
      sf: 'OOGRROGGRBBB',
      arrows: [['RTMM', 'RBMM'], ['RBMM', 'RTMM'], ['MBMM', 'RMMM'], ['RMMM', 'MBMM']],
      chance: 18,
      algorithms: [
        ["RUR'F'", "RUR'U'", "R'FR2U'R'[U']"],
      ],
    },

    {
      name: 'T Perm',
      sf: 'OOGRBOGRRBGB',
      arrows: [['RTMM', 'RBMM'], ['RBMM', 'RTMM'], ['LMMM', 'RMMM'], ['RMMM', 'LMMM']],
      chance: 18,
      algorithms: [
        ["RUR'U'", "R'FR2U'", "R'U'", "RUR'F'"],
      ],
    },

    {
      name: 'F Perm',
      sf: 'BGOGOBOBGRRR',
      arrows: [['MTMM', 'MBMM'], ['MBMM', 'MTMM'], ['RTMM', 'RBMM'], ['RBMM', 'RTMM']],
      chance: 18,
      algorithms: [
        ["R'U'F'", "RUR'U'", "R'FR2U'", "R'U'RU", "R'UR"],
        ['y', "R'U2R'U'", 'y', "R'F'R2U'", "R'UR'F", "RU'F"],
      ],
    },

    {
      name: 'V Perm',
      sf: 'RGOGOBORRBBG',
      arrows: [['LTMM', 'RBMM'], ['RBMM', 'LTMM'], ['MTMM', 'RMMM'], ['RMMM', 'MTMM']],
      chance: 18,
      algorithms: [
        ["R'UR'U'", 'y', "R'F'R2U'", "R'UR'F", 'RF'],
      ],
    },

    {
      name: 'Y Perm',
      sf: 'RBOGGBORRBOG',
      arrows: [['LTMM', 'RBMM'], ['RBMM', 'LTMM'], ['LMMM', 'MTMM'], ['MTMM', 'LMMM']],
      chance: 18,
      algorithms: [
        ['F', "RU'R'U'", "RUR'F'", "RUR'U'", "R'FRF'"],
      ],
    },

    {
      name: 'Na Perm',
      sf: 'OORBBGRROGGB',
      arrows: [['LMMM', 'RMMM'], ['RMMM', 'LMMM'], ['LBMM', 'RTMM'], ['RTMM', 'LBMM']],
      chance: 72,
      algorithms: [
        ["RUR'U", "RUR'F'", "RUR'U'", "R'FR2U'", "R'U2", "RU'R'"],
        ['z', "UR'D", "R2U'RD'", "UR'D", "R2U'RD'", "[R']z'"],
      ],
    },

    {
      name: 'Nb Perm',
      sf: 'ROOGBBORRBGG',
      arrows: [['LMMM', 'RMMM'], ['RMMM', 'LMMM'], ['LTMM', 'RBMM'], ['RBMM', 'LTMM']],
      chance: 72,
      algorithms: [
        ["R'URU'", "R'F'U'F", "RUR'F", "R'F'", "RU'R"],
        ["R'UL'U2RU'L", "R'UL'U2RU'L", '[U]'],
      ],
    },

    {
      name: 'Ga Perm',
      sf: 'GBRBOGRRBOGO',
      arrows: [['LBLT', 'LTLM'], ['LTMT', 'RTMT'], ['RTMM', 'LBMM'], ['MTLB', 'LMMM'], ['LMRM', 'RMMM'], ['RMLT', 'MTMM']],
      chance: 18,
      algorithms: [
        ['R2U', "R'UR'U'", "RU'R2", "DU'", "R'URD'", '[U]'],
        ['R2u', "R'UR'U'", "Ru'R2y'", "R'UR"],
      ],
    },

    {
      name: 'Gb Perm',
      sf: 'OROGORBBGRGB',
      arrows: [['LTLM', 'LBLM'], ['LBMM', 'RTMM'], ['RTMT', 'LTMT'], ['LMRT', 'MTMM'], ['MTRB', 'RMMM'], ['RMLM', 'LMMM']],
      chance: 18,
      algorithms: [
        ["F'U'F", "R2uR'U", "RU'Ru'", "R2'"],
        ["y'R'U'yF", "R2uR'U", "RU'Ru'", "R2'"],
        ["y'D", "R'U'RU", "D'", "R2UR'U", "RU'RU'", "R2'[U']"],
      ],
    },

    {
      name: 'Gc Perm',
      sf: 'GRRBOGRGBOBO',
      arrows: [['LTLM', 'LBLM'], ['LBMB', 'RBMB'], ['RBMM', 'LTMM'], ['LMRM', 'RMMM'], ['RMLB', 'MBMM'], ['MBLT', 'LMMM']],
      chance: 18,
      algorithms: [
        ["R2U'", "RU'RU", "R'UR2D'", "URU'R'", "D[U']"],
        ["y2R2'F2", "RU2'RU2'", "R'F", "RUR'U'", "R'FR2"],
      ],
    },

    {
      name: 'Gd Perm',
      sf: 'GBRBGGROBORO',
      arrows: [['LTMT', 'RTMT'], ['RTMM', 'LBMM'], ['LBLM', 'LTLM'], ['LMRB', 'MBMM'], ['MBMT', 'MTMM'], ['MTLB', 'LMMM']],
      chance: 18,
      algorithms: [
        ["D'", "RUR'U'", 'D', "R2U'RU'", "R'UR'U", 'R2[U]'],
        ["RUR'", "y'", "R2u'RU'", "R'UR'u", 'R2'],
      ],
    },
  ],
};
